// event-roster-position.js
import { DELETE_QUESTION_ACTION } from './event-questions'

// Reducer
const initialState = {}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_QUESTION_ACTION: {
            const { ...rosterPositions } = state

            const { id: questionId } = action.question

            /**
             * Iterate over all roster positions. If any roster position contains id of question that has been deleted,
             * delete that question id as well
            */
            for(const [rosterPositionId, rosterPosition] of Object.entries(rosterPositions)) {
                rosterPositions[rosterPositionId].questions = rosterPosition.questions.filter(rosterPositionQuestionId => rosterPositionQuestionId !== questionId)
            }

            return rosterPositions
        }
        default:
            return state
    }
}
